// owl API 文档： https://km.sankuai.com/page/1291907878
function addError(level, type, error, tags) {
  // 过滤掉安全组的扫描
  const lua = navigator.userAgent.toLowerCase()
  if (/mtdp-infosec/.test(lua)) return

  let errorMsg = ''
  if (Object.prototype.toString.call(error) === '[object Error]') {
    errorMsg = error.message
  } else {
    errorMsg = error ? JSON.stringify(error, null, 2) : ''
  }

  window.owl(
    'addError',
    {
      name: type,
      msg: errorMsg
    },
    {
      level: level,
      tags
    }
  )
}
/**
 * 错误埋点上报 https://km.sankuai.com/page/1291907878#id-addError
 * @param type string，错误名称
 * @param error 错误详情，string or Object or Error 实例
 * @param tags 异常的自定义信息 Object
 */
export function reportError(type, error, tags) {
  addError('error', type, error, tags)
}

export function reportWarn(type, error, tags) {
  addError('warn', type, error, tags)
}

export function reportInfo(type, info, tags) {
  addError('info', type, info, tags)
}
/**
 * 上报自定义性能指标 https://km.sankuai.com/page/1291907878#id-addPoint
 * @param position 表示自定义性能指标的位置。可选值为 0 - 31 之间的整数，逐一对应测速点1 - 测速点32
 * @param duration 表示性能指标的时间值
 * @param timeStamp 表示当前的时间戳
 * @param xxx duration 与 timeStamp 属性二选一
 */
export function reportPoint(position, duration = -1, timeStamp = -1) {
  const options = {
    position
  }
  if (duration === -1) {
    delete options.duration
  }
  if (timeStamp === -1) {
    delete options.timeStamp
  }
  window.owl('addPoint', options)
}
/**
 * 手动上报自定义请求信息，通常用于上报业务状态码 https://km.sankuai.com/page/1291907878#id-addApi
 * @param url 请求 url
 * @param networkCode 网络状态码
 * @param statusCode 业务状态码
 * @param content
 * @param responseTime 请求耗时
 */
export function reportApi(url, networkCode, statusCode, content, responseTime = 0) {
  window.owl('addApi', {
    name: url,
    networkCode,
    statusCode,
    responseTime,
    content
  })
}
/**
 * 自定义指标上报 https://km.sankuai.com/custom/onecloud/page/253147798#id-%E6%89%8B%E5%8A%A8%E4%B8%8A%E6%8A%A5%E8%87%AA%E5%AE%9A%E4%B9%89%E6%8C%87%E6%A0%87
 * @param name 指标名称
 * @param value 指标值
 * @param tags 维度信息（键值对）
 * @returns void
 */
export function reportMessage(name, value, tags) {
  // 过滤掉安全组的扫描
  const lua = navigator.userAgent.toLowerCase()
  if (/mtdp-infosec/.test(lua)) return
  let metricInst = window.owl('newMetricInst')
  metricInst && metricInst.setTags(tags) // 设置维度信息
  metricInst && metricInst.setMetric(name, value) // 设置指标数据
}
